import { CommodityType } from '@app/shared/enums/commodity-type';
import { Address } from '@app/shared/models/address';
import { defaultContractLengths } from '@app/shared/models/default-contract-lengths';
import { UtilityZones } from '@app/shared/models/utility-information';
import { PricingSource } from '@app/shared/services/pricing-source.service';
import { UtilityHubIdentity } from '@auth/models/utility-hub-identity';
import { UtilityHubConfiguration } from '@configuration/models/utilityhub-configuration';

export class RenewalsCustomerDetailsData {
  customerZipCode: string;
  quoteRequestId: any;
  utilities: string[];
  iso: string;
  zones: string[];
  weatherZones: string[];
  loadingUtilities: boolean = false;
  emitEventOnValueChange = true;
  stateCode: string;
  commodityTypeEnum = CommodityType;
  commodity: string;
  utilityZones: UtilityZones[];
  bundledRate: string;
  annualUsage: number;
  quoteRequestState: any;
  customerDetail: any;
  quoteConfig: any;
  notes: any;
  showContractLengths: boolean = true;
  contractLengths: any;
  showPlusButton: any;
  defaultAllSelection: any;
  showAllButton: any;
  files: any;
  productTypes = [{ productType: 'Fixed' }];
  defaultContractLengthButtonsToShow = defaultContractLengths;
  dunsEnabled: any;
  isQuickSubmission: any;
  companyDetails: any;
  userIdentity: UtilityHubIdentity;
  utilityHubConfiguration: UtilityHubConfiguration;
  utilityShort: any;
  showValidation: boolean = false;
  isRequestedStatus: boolean;
  uom: string;
  address: Address;
  externalId: string;
  isGasEnabled: boolean = false;
  isElectricEnabled: boolean = false;
  isGasChecked: boolean = false;
  isElectricChecked: boolean = false;
  pricingSource: PricingSource;
  showControls = {
    showIso: true,
    showZone: true,
    showBundledRateCheckbox: false,
    loadingUtilities: false,
    emitEventOnValueChange: true,
  };
  originalQuoteRequestId: number | null;
}
